import React from 'react';
import './AppStore.css';

import Google from '../../assets/google.png';
import Apple from '../../assets/apple.png';

const AppStore = () => {
  return (
    <section className="appstore">
      <h3 className="appstore__title">Download for Andriod/ios</h3>
      <div className="appstore__cta-container">
        <button type="button" to="/" className="appstore__cta google">
          <div className="hero__cta-logo">
            <img src={Google} alt="" />
          </div>
          <div className="appstore__cta-text">
            <p>GET IT ON</p>
            <p>Google Play</p>
          </div>
        </button>

        <button type="button" to="/" className="appstore__cta apple">
          <div className="hero__cta-logo">
            <img src={Apple} alt="" />
          </div>
          <div className="appstore__cta-text">
            <p>Download on the</p>
            <p>App Store</p>
          </div>
        </button>
      </div>
    </section>
  );
};

export default AppStore;
